module.exports = __webpack_public_path__ + "img/afef135.jpg";